require(['jquery', 'js/glider-min'], function ($) {
	"use strict";
	// Toggle Product Features
	const triggers = $('.js-features-trigger'),
		itemFeatures = '.js-product-form',
		itemInfo = '.js-product-slider-item-info',
		triggerOpen = '.js-features-trigger-open';

	triggers.click(function () {
		const slide = $(this).closest('.js-product-slider-reborn-slide');

		$(slide).find(itemFeatures).toggleClass('is-visible');
		$(slide).find(itemInfo).toggleClass('is-hidden');
		$(slide).find(triggerOpen).toggleClass('is-hidden');
		$(slide).find('.price-title-configurable').toggleClass('is-visible');
		$(slide).find('.price-box').toggleClass('is-visible');
		const swatch = $(slide).find('.swatch-attribute');
		const label = $(slide).find('.swatch-attribute-label');
		const swatchColor = $(slide).find('.swatch-attribute.color');
		const priceBox = $(slide).find('.price-box__label');
		swatch.each(function () {
			$(this).css('display', 'none');
		});
		label.css('display','flex');
		swatch.css('display','flex');
		swatchColor.css('display', 'flex');
		priceBox.css('display','flex');
		if (!$(slide).find(itemFeatures).hasClass('is-visible')) {
			$(slide).find(itemFeatures).trigger('reset');
			$(slide).find('.swatch-option').removeClass('selected');
			swatch.each( function() {
				$(this).find('.swatch-option').each( function() {
					$(this).removeClass('selected');
					$(this).removeClass('disabled');
					$(this).attr('aria-checked', false);
					$(this).attr('disabled', false);
				});
				$(this).css('display', 'none');
				swatchColor.css('display', 'flex');
				label.css('display','none');
				priceBox.css('display','none');
				$(this).removeAttr('option-selected');
			});
		}
	});


// Form Validations
	const submitBtn = $('.js-submit-form');

	submitBtn.click(function () {
		const form = $(this).closest('.js-product-form'),
			age = $(form).find('.groesse .swatch-option'),
			color = $(form).find('.color .swatch-option'),
			errorAge = $(form).find('.js-product-form-error-age'),
			errorColor = $(form).find('.js-product-form-error-color');


		let ageCheck = 0;
		for (let i = 0; i < age.length; i++) {
			if (age[i].classList.contains('selected')) {
				ageCheck++;
				break;
			}
		}
	})

// Slider settings
	const productSliders = document.querySelectorAll(".js-product-slider-reborn");

	if (productSliders) {
		productSliders.forEach(function (productSlider) {
			let slider = productSlider.querySelector('.slides');
			if (!slider) {
				return;
			}
			let slidesToShow = slider.getAttribute('data-slides-to-show');

			// Determine closest scope that may contain controls
			const scope = productSlider.closest('.c-product-slider-reborn') || productSlider;
			const sliderPrev = productSlider.querySelector('.js-product-slider-reborn-prev') || scope.querySelector('.js-product-slider-reborn-prev');
			const sliderNext = productSlider.querySelector('.js-product-slider-reborn-next') || scope.querySelector('.js-product-slider-reborn-next');
			const bullets = productSlider.querySelector('.js-product-slider-reborn-bullets') || scope.querySelector('.js-product-slider-reborn-bullets');

			if (!slidesToShow || slidesToShow === '0') {
				slidesToShow = '3';
			}

			const gliderOptions = {
				draggable: true,
				slidesToShow: 3,
				slidesToScroll: 1,
				scrollLock: false,
				rewind: true,
				responsive: [
					{
						breakpoint: 0,
						settings: {
							slidesToShow: 1.1,
							slidesToScroll: 1
						}
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 2.5,
							slidesToScroll: 1
						}
					},
					{
						breakpoint: 1024,
							settings: {
								slidesToShow: Number(slidesToShow) + 0.5,
								slidesToScroll: 1
							}
					},
				]
			};

			// Attach controls only if present
			if (sliderPrev && sliderNext) {
				gliderOptions.arrows = { prev: sliderPrev, next: sliderNext };
			}
			if (bullets) {
				gliderOptions.dots = bullets;
			}

			new Glider(slider, gliderOptions);
		})
	}
});
